<template>
  <div>
    <div id="projectName">
      <h5>{{project.projectName}}</h5>
    </div>
    <div id="inspections">
      <div v-for="(inspection, index) of project.inspections" :key="inspection.ptracTaskId">
        <hr v-if="index !== 0" />
        <inspection-marker-info-window-content :inspection="inspection" :for-project-marker="true" :vue = "vue"/>
      </div>
    </div>
  </div>
</template>

<script>
import InspectionMarkerInfoWindowContent from '@/components/Dashboard/Views/InspectorRouting/InspectionMarkerInfoWindowContent.vue'

export default {
  components: {
    InspectionMarkerInfoWindowContent
  },
  props: ['project', 'vue'],
}
</script>

